<label class="d-flex flex-column gap-1" for="organization-picker">
  <span class="av-meta">{{ label() | translate }}</span>

  <select
    id="organization-picker"
    class="av-field"
    [value]="value()"
    [disabled]="disabled()"
    (change)="select($any($event.target).value)"
    data-testid="organization-picker"
  >
    <option value="">{{ emptyLabel() | translate }}</option>

    @for (organization of organizations(); track organization.id) {
      <option [value]="organization.id">{{ organization.displayName }}</option>
    }
  </select>
</label>
